module.exports = __webpack_public_path__ + "static/img/icon_current.0b9bcdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/dynamicForm/icon_current.png
// module id = OjpE
// module chunks = 55